/** @format */

import { api } from 'utility';
import {
  getBusinessUrl,
  getBusinessOwnerInfoUrl,
  getSetFianancialPermissionUrl,
  getBisinessSettingUrl,
  getVerifyBisinessUrl,
  getBusinessSituationUrl,
  getBusinessHintReadUrl,
  getBusinessHintUrl,
} from 'URLs';

export function businessInfoService() {
  return api.get(getBusinessUrl()).then((res) => res.data);
}

export function updateBusinessService(params) {
  return api.put(getBusinessUrl(), params);
}

export function reviewRequestService() {
  return api.post(getVerifyBisinessUrl());
}

export function businessSettingService() {
  return api.get(getBisinessSettingUrl()).then((res) => res.data);
}

export function businessSituationGetService() {
  return api.get(getBusinessSituationUrl()).then((res) => res.data);
}

export function businessHintReadService(item) {
  return api.post(getBusinessHintReadUrl(item)).then((res) => res.data);
}

export function businessHintService(item) {
  return api.post(getBusinessHintUrl(item));
}

export function businessOwnerGetService() {
  const headers = {
    'idToken': 'true',
  }
  return api.get(getBusinessOwnerInfoUrl(), { headers: { ...headers } }).then((res) => res.data);
}

export function businessOwnerPutService(params) {
  return api.put(getBusinessOwnerInfoUrl(), params);
}

export function businessGrantPermission(params) {
  return api.post(getSetFianancialPermissionUrl(), params);
}
